/**
 * Locale-specific formatters and helpers
 */

// Mapping of locale to the appropriate million/billion abbreviations
export const getLocalizedAbbreviations = (locale: string = 'en-US'): { million: string; billion: string; } => {
  // Extract language code from locale
  const language = locale.split('-')[0].toLowerCase();
  
  // Define abbreviations for common languages
  switch (language) {
    case 'de': // German
      return { million: 'Mio.', billion: 'Mrd.' };
    case 'fr': // French
      return { million: 'M', billion: 'Md' };
    case 'es': // Spanish
      return { million: 'M', billion: 'MM' };
    case 'it': // Italian
      return { million: 'Mln', billion: 'Mld' };
    case 'nl': // Dutch
      return { million: 'mln', billion: 'mld' };
    case 'pt': // Portuguese
      return { million: 'M', billion: 'MM' };
    case 'ru': // Russian
      return { million: 'млн', billion: 'млрд' };
    case 'zh': // Chinese
      return { million: '百万', billion: '十亿' };
    case 'ja': // Japanese
      return { million: '百万', billion: '十億' };
    default: // Default to English
      return { million: 'M', billion: 'B' };
  }
};
